<h5 class="title" i18n="plan kpi dashboard card title|The title of the card that shows the current plan of the user and its expiration date@@planKpiDashboardTitle">Plan</h5>
<div class="icon mt">
  <i class="fa fa-user fa-4x"></i>
</div>
<div class="value-group">
  <span class="value">{{ value }}</span>
</div>
<div class="manage-button" *ngIf="hasManageButton">
  <a [routerLink]="'/billing/manage'" class="btn btn-custom" i18n="@@manageSubscriptionLabel">Manage subscription</a>
</div>
<div class="expiration mt"><span i18n="expiration date prefix label plan kpi card|The expiration prefix label before the date the current plan expires@@expirationPrefixLabelPlanKpiCard">Expiration:</span><span>{{ " " + expirationString }}</span></div>
